<script setup lang="ts">
import type { ToastActionProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { ToastAction } from 'reka-ui'

const props = defineProps<ToastActionProps & { class?: HTMLAttributes['class'] }>()
const appConfig = useAppConfig()
const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props
  return delegated
})
</script>

<template>
  <ToastAction v-bind="delegatedProps" :class="cn(appConfig.ui.toast.slots.action, props.class)">
    <slot />
  </ToastAction>
</template>
